import { TableService } from './table-service';
import { Contact } from '../../../models/contact';
import { ContactsQuery } from '../../../models/contacts-query';
import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import {
    selectContactDeleting,
    selectContactsTableBusy,
    selectContactsTableCount,
    selectContactsTablePage,
    selectContactsTableQuery,
    selectContactsTableSelection
} from '../../../store/contacts-table/contacts-table.state';
import {
    contactsTableChangePage,
    contactsTableMasterToggle,
    contactsTableSort,
    contactsTableToggle
} from '../../../store/contacts-table/contacts-table.actions';
import { Sort } from '@angular/material/sort';
import { EntityEnum } from '../../../enum/entity.enum';
import { PageEvent } from '@angular/material/paginator';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ContactsTableService extends TableService<Contact, ContactsQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return combineLatest([this.store.select(selectContactsTableBusy), this.store.select(selectContactDeleting)]).pipe(
            map(([contactsBusy, contactDeleting]) => contactsBusy || contactDeleting)
        );
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            'CONTACT_ATTN', 'CONTACT_ORGANIZATION', 'CONTACT_CITY', 'CONTACT_POSTALCODE', 'CONTACT_COUNTRY',
            'CONTACT_REFERENCE', 'CONTACT_ADDRESS_BOOK',
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Contact[]> {
        return this.store.select(selectContactsTablePage);
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectContactsTableSelection);
    }

    protected getTableQueryObservable(): Observable<ContactsQuery> {
        return this.store.select(selectContactsTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectContactsTableCount);
    }

    public pageChange(page: PageEvent): void {
        this.store.dispatch(contactsTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    public sortChange(sort: Sort): void {
        this.store.dispatch(contactsTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    public toggle(id: string): void {
        this.store.dispatch(contactsTableToggle({ id }));
    }

    public toggleAll(): void {
        this.store.dispatch(contactsTableMasterToggle());
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.CONTACT;
    }
}
